<template>
    <div class="card border-secondary">
        <div class="card-header">
            {{ typename?.name }}
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm" v-if="showFieldId">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            :id="`input-${parendId}-typename-${idx}-id`"
                            :name="`${parendId}-typename-${idx}-id`"
                            v-model.trim="typename.property_id"
                            :placeholder="$t(`${helpTranslateID}.id.placeholder`)"
                            v-validate="'required'"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError(`${parendId}-typename-${idx}-id`, vScope) }]"
                            :error="fnFirstError(`${parendId}-typename-${idx}-id`, vScope)">
                            {{ $t(`${modelTranslateID}.id`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-sm" v-if="showFieldName">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            :id="`input-${parendId}-typename-${idx}-name`"
                            :name="`${parendId}-typename-${idx}-name`"
                            v-model.trim="typename.property_name"
                            :placeholder="$t(`${helpTranslateID}.name.placeholder`)"
                            v-validate="'required'"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError(`${parendId}-typename-${idx}-name`, vScope) }]"
                            :error="fnFirstError(`${parendId}-typename-${idx}-name`, vScope)">
                            {{ $t(`${modelTranslateID}.name`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-sm">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            :id="`input-${parendId}-typename-${idx}-title`"
                            :name="`${parendId}-typename-${idx}-title`"
                            v-model.trim="typename.property_title"
                            :placeholder="$t(`${helpTranslateID}.title.placeholder`, {typename: typename?.typename})"
                            v-validate="''"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError(`${parendId}-typename-${idx}-title`, vScope) }]"
                            :error="fnFirstError(`${parendId}-typename-${idx}-title`, vScope)">
                            {{ $t(`${modelTranslateID}.title`) }}
                        </MaterialInput>
                    </div>
                </div>
                <!-- <div class="col-sm-auto pr-sm-4 d-flex align-items-center">
                    {{ $t(`${modelTranslateID}.title.title`) }}
                </div>
                <div class="col-sm">
                    <SimpleInput
                        :readonly="readonlyForm"
                        :disabled="readonlyForm"
                        class="city-form-group city-bg city-bg-sm m-0"
                        :id="`input-typename-${idx}-title`"
                        :name="`typename-${idx}-title`"
                        :placeholder="$t(`${helpTranslateID}.title.placeholder`, {typename: typename?.typename})"
                        v-model.trim="form.typenames[idx].title"
                        v-validate="''"
                        :data-vv-scope="vScope"
                        :inputClasses="[{'is-invalid': fnHasError(`typename-${idx}-title`, vScope) }]"
                        :error="fnFirstError(`typename-${idx}-title`, vScope)"/>
                </div> -->
                <div class="col-sm-auto d-flex align-items-center form-group">
                    <button
                        type="button"
                        class="btn btn-info btn-sm min-w-auto my-0 mx-auto d-block"
                        @click="onResetProperties">
                        <i class="fas fa-repeat" />
                    </button>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <HelpSpan :helpText="`${helpTranslateID}.fields`" />
                </div>
            </div>
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col" class="text-center">{{ $t(`${modelTranslateID}.properties.name`) }}</th>
                        <th scope="col" class="text-center">{{ $t(`${modelTranslateID}.properties.type`) }}</th>
                        <th scope="col" class="text-center w-100px">{{ $t(`${modelTranslateID}.properties.order`) }}</th>
                        <th scope="col" v-if="!readonlyForm"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(property, pIdx) in (typename.properties ?? [])"
                        :key="`typename-${idx}-property-${pIdx}`">
                        <td>
                            {{ property.source_name }}
                        </td>
                        <td>
                            <SimpleInput
                                :readonly="readonlyForm"
                                :disabled="readonlyForm"
                                class="city-form-group city-bg city-bg-sm"
                                :id="`input-${parendId}-typename-${idx}-property-${pIdx}-name`"
                                :name="`${parendId}-typename-${idx}-property-${pIdx}-name`"
                                v-model.trim="typename.properties[pIdx].name"
                                :required="true"
                                v-validate="'required'"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError(`${parendId}-typename-${idx}-property-${pIdx}-name`, vScope) }]"
                                :error="fnFirstError(`${parendId}-typename-${idx}-property-${pIdx}-name`, vScope)"/>
                        </td>
                        <td>
                            <SimpleSelect
                                :disabled="readonlyForm"
                                class=""
                                :id="`input-${parendId}-typename-${idx}-property-type`"
                                :name="`${parendId}-typename-${idx}-property-${pIdx}-type`"
                                label="name"
                                v-model.trim="typename.properties[pIdx].type"
                                :options="propertyTypes"
                                :reduce="option => option.id"
                                :required="true"
                                v-validate="'required'"
                                :data-vv-scope="vScope"
                                :inputClasses="['city-form-group','city-bg','city-bg-sm',{'is-invalid': fnHasError(`${parendId}-typename-${idx}-property-${pIdx}-type`, vScope) }]"
                                :error="fnFirstError(`${parendId}-typename-${idx}-property-${pIdx}-type`, vScope)"/>
                        </td>
                        <td>
                            <SimpleInput
                                :readonly="readonlyForm"
                                :disabled="readonlyForm"
                                class="city-form-group city-bg city-bg-sm"
                                :id="`input-${parendId}-typename-${idx}-property-${pIdx}-order`"
                                :name="`${parendId}-typename-${idx}-property-${pIdx}-order`"
                                v-model.trim="typename.properties[pIdx].order"
                                type="number"
                                :required="true"
                                v-validate="'required|integer'"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError(`${parendId}-typename-${idx}-property-${pIdx}-order`, vScope) }]"
                                :error="fnFirstError(`${parendId}-typename-${idx}-property-${pIdx}-order`, vScope)"/>
                        </td>
                        <td class="col-sm-auto text-center d-print-none" v-if="!readonlyForm">
                            <button
                                type="button"
                                class="btn btn-danger btn-sm min-w-auto my-0 mx-auto d-block"
                                @click="onRemoveProperty(pIdx)">
                                <i class="fas fa-trash" />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import ValidateMixin from '@/app/shared/mixins/ValidateMixin';

export default {
    mixins: [
        ValidateMixin,
    ],
    components: {
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
    },
    inject: {
        parentValidator: 'parentValidator',
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        idx: {
            type: Number,
            default: 0,
        },
        parendId: {
            type: String,
            default: '',
        },
        idSubPanel: {
            type: String,
            default: 'typename',
        },
        baseTranslateID: {
            type: String,
        },
        vScope: {
            type: String,
            default: 'form',
        },
        readonlyForm: {
            type: Boolean,
            default: true,
        },
        showFieldId: {
            type: Boolean,
            default: false,
        },
        showFieldName: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            typename: {},
        }
    },
    created() {
        this.$validator = this.parentValidator;
    },
    computed: {
        modelTranslateID() {
            return this.idSubPanel ? `${this.baseTranslateID}.model.${this.idSubPanel}` : `${this.baseTranslateID}.model`;
        },
        helpTranslateID() {
            return this.idSubPanel ? `${this.baseTranslateID}.help.${this.idSubPanel}` : `${this.baseTranslateID}.help`;
        },
        propertyTypes() {
            return [
                {id: 'int', name: 'Inteiro'},
                {id: 'long', name: 'Long'},
                {id: 'double', name: 'Double'},
                {id: 'decimal', name: 'Decimal'},
                {id: 'number', name: 'Number'},
                {id: 'string', name: 'String'},
                {id: 'image', name: 'Image'},
                {id: 'link', name: 'URL'},
            ];
        },
    },
    methods: {
        onResetProperties() {
            this.$emit('onReset');
        },
        onRemoveProperty(idx) {
            this.typename.properties.splice(idx, 1);
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler: function(value, oldValue){
                this.typename = value;
            }
        },
        typename: {
            deep: true,
            handler: function(value, oldValue){
                this.$emit('input', value);
            }
        },
    }
}
</script>

<style scoped lang="scss">
</style>